export { default } from 'src/apps/LearningSettings';
